import { Transformation } from './transformation';

export const daysOfTheWeekArray = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
] as const;

export type DaysOfTheWeek = typeof daysOfTheWeekArray[number];

export interface TemplateSchedule {
    enabled: boolean;
    days: DaysOfTheWeek[];
    time: {
        fromHours: number;
        fromMinutes: number;
        toHours: number;
        toMinutes: number;
    };
}

export interface TemplateListItem {
    name: string;
    id: string;
}

export interface CreateTemplateData {
    whitelist?: string[];
    whitelistEnabled: boolean;
    blacklist?: string[];
    blacklistEnabled: boolean;
    name: string;
    recordersCount: number;
    recordOnStart: boolean;
    recordExtendedElementData: boolean;
    schedule: TemplateSchedule;
    creationTime: Date;
    fieldRedactionEnabled: boolean;
    transformations?: Transformation[];
    mergeDifferentHosts: boolean;
}

interface GeneratedTemplateData {
    id?: string;
    whitelistCount?: number;
    blacklistCount?: number;
    eventCount?: number;
    default: boolean;
    readOnly: boolean;
}

export type Template = CreateTemplateData & GeneratedTemplateData;
